import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';

import { getItem } from 'apis/restaurant-api/merchant-admin/menu2/api';
import { localize } from 'common/utils';

import { CampaignsQueryKeys } from '../campaignsQueryKeys';

type UseDiscountedItemProps = {
  menuId?: string;
  itemId?: string;
};
export const useDiscountedItem = ({ menuId, itemId }: UseDiscountedItemProps) => {
  const { locale } = useIntl();
  const {
    data: discountedItem = null,
    isFetching,
    error,
  } = useQuery(CampaignsQueryKeys.GET_ITEM(menuId ?? '', itemId ?? ''), () => getItem(menuId ?? '', itemId ?? ''), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
    enabled: menuId !== undefined && itemId !== undefined,
  });

  return {
    discountedItem: discountedItem
      ? {
          ...discountedItem,
          name: localize(discountedItem.name, locale).trim(),
          description: localize(discountedItem.description, locale),
        }
      : undefined,
    isFetching,
    error,
  };
};
